import { Flame } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="services-marquee" className="relative border-y border-[#e8e5e0] bg-white py-4 overflow-hidden">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-6 px-6 shrink-0">
            <span className="font-tech text-xs sm:text-sm tracking-[0.3em] text-neutral-400">{item}</span>
            <Flame size={12} className="text-[#ff6b00]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const EssenceMarquee = () => {
  const { t } = useLang();
  const items = Array.from({ length: 6 }, () => t.essence);
  return (
    <div data-testid="essence-marquee" className="relative py-14 overflow-hidden select-none" aria-hidden="true">
      <div className="marquee-track-slow">
        {items.map((item, i) => (
          <span key={i} className="font-display italic text-6xl sm:text-7xl lg:text-8xl text-outline whitespace-nowrap px-8">
            {item} —
          </span>
        ))}
      </div>
    </div>
  );
};
